var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoNames({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 211,
    viewBox: "0 0 150 211",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M122.96 27.2656H0.000152588V175.103H122.96V27.2656Z",
    fill: "#DBF0F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5092 40.5566H10.4967V43.1467H41.5092V40.5566Z",
    fill: "#1698B8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4753 40.5566H45.4627V43.1467H76.4753V40.5566Z",
    fill: "#1698B8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M111.441 40.5566H80.4283V43.1467H111.441V40.5566Z",
    fill: "#1698B8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5092 45.873H10.4967V48.4631H41.5092V45.873Z",
    fill: "#1698B8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4753 45.873H45.4627V48.4631H76.4753V45.873Z",
    fill: "#1698B8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M111.441 45.873H80.4283V48.4631H111.441V45.873Z",
    fill: "#1698B8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5092 51.1211H10.4967V53.7111H41.5092V51.1211Z",
    fill: "#1698B8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4753 51.1211H45.4627V53.7111H76.4753V51.1211Z",
    fill: "#1698B8"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M111.441 51.1211H80.4283V53.7111H111.441V51.1211Z",
    fill: "#1698B8"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5092 56.3701H10.4967V58.9602H41.5092V56.3701Z",
    fill: "#1698B8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4753 56.3701H45.4627V58.9602H76.4753V56.3701Z",
    fill: "#1698B8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M111.441 56.3701H80.4283V58.9602H111.441V56.3701Z",
    fill: "#1698B8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5092 61.6182H10.4967V64.2082H41.5092V61.6182Z",
    fill: "#1698B8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4753 61.6182H45.4627V64.2082H76.4753V61.6182Z",
    fill: "#1698B8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M111.441 61.6182H80.4283V64.2082H111.441V61.6182Z",
    fill: "#1698B8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5092 66.9346H10.4967V69.5246H41.5092V66.9346Z",
    fill: "#1698B8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4753 66.9346H45.4627V69.5246H76.4753V66.9346Z",
    fill: "#1698B8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M111.441 66.9346H80.4283V69.5246H111.441V66.9346Z",
    fill: "#1698B8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5092 72.1826H10.4967V74.7727H41.5092V72.1826Z",
    fill: "#1698B8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4753 72.1826H45.4627V74.7727H76.4753V72.1826Z",
    fill: "#1698B8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M111.441 72.1826H80.4283V74.7727H111.441V72.1826Z",
    fill: "#1698B8"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5092 77.4307H10.4967V80.0207H41.5092V77.4307Z",
    fill: "#1698B8"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4753 77.4307H45.4627V80.0207H76.4753V77.4307Z",
    fill: "#1698B8"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M111.441 77.4307H80.4283V80.0207H111.441V77.4307Z",
    fill: "#1698B8"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5092 82.6797H10.4967V85.2697H41.5092V82.6797Z",
    fill: "#1698B8"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4753 82.6797H45.4627V85.2697H76.4753V82.6797Z",
    fill: "#1698B8"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M111.441 82.6797H80.4283V85.2697H111.441V82.6797Z",
    fill: "#1698B8"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5092 87.9961H10.4967V90.5862H41.5092V87.9961Z",
    fill: "#1698B8"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4753 87.9961H45.4627V90.5862H76.4753V87.9961Z",
    fill: "#1698B8"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M111.441 87.9961H80.4283V90.5862H111.441V87.9961Z",
    fill: "#1698B8"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5092 93.2441H10.4967V95.8342H41.5092V93.2441Z",
    fill: "#1698B8"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4753 93.2441H45.4627V95.8342H76.4753V93.2441Z",
    fill: "#1698B8"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M111.441 93.2441H80.4283V95.8342H111.441V93.2441Z",
    fill: "#1698B8"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5092 98.4922H10.4967V101.082H41.5092V98.4922Z",
    fill: "#1698B8"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4753 98.4922H45.4627V101.082H76.4753V98.4922Z",
    fill: "#1698B8"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M111.441 98.4922H80.4283V101.082H111.441V98.4922Z",
    fill: "#1698B8"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5092 103.74H10.4967V106.33H41.5092V103.74Z",
    fill: "#1698B8"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4753 103.74H45.4627V106.33H76.4753V103.74Z",
    fill: "#1698B8"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M111.441 103.74H80.4283V106.33H111.441V103.74Z",
    fill: "#1698B8"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5092 109.057H10.4967V111.647H41.5092V109.057Z",
    fill: "#1698B8"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4753 109.057H45.4627V111.647H76.4753V109.057Z",
    fill: "#1698B8"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M111.441 109.057H80.4283V111.647H111.441V109.057Z",
    fill: "#1698B8"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5092 114.305H10.4967V116.895H41.5092V114.305Z",
    fill: "#1698B8"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4753 114.305H45.4627V116.895H76.4753V114.305Z",
    fill: "#1698B8"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M111.441 114.305H80.4283V116.895H111.441V114.305Z",
    fill: "#1698B8"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5092 119.554H10.4967V122.144H41.5092V119.554Z",
    fill: "#1698B8"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4753 119.554H45.4627V122.144H76.4753V119.554Z",
    fill: "#1698B8"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M111.441 119.554H80.4283V122.144H111.441V119.554Z",
    fill: "#1698B8"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5092 124.802H10.4967V127.392H41.5092V124.802Z",
    fill: "#1698B8"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4753 124.802H45.4627V127.392H76.4753V124.802Z",
    fill: "#1698B8"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M111.441 124.802H80.4283V127.392H111.441V124.802Z",
    fill: "#1698B8"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5092 130.118H10.4967V132.708H41.5092V130.118Z",
    fill: "#1698B8"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4753 130.118H45.4627V132.708H76.4753V130.118Z",
    fill: "#1698B8"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M111.441 130.118H80.4283V132.708H111.441V130.118Z",
    fill: "#1698B8"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5092 135.366H10.4967V137.956H41.5092V135.366Z",
    fill: "#1698B8"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4753 135.366H45.4627V137.956H76.4753V135.366Z",
    fill: "#1698B8"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M111.441 135.366H80.4283V137.956H111.441V135.366Z",
    fill: "#1698B8"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5092 140.614H10.4967V143.204H41.5092V140.614Z",
    fill: "#1698B8"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4753 140.614H45.4627V143.204H76.4753V140.614Z",
    fill: "#1698B8"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M111.441 140.614H80.4283V143.204H111.441V140.614Z",
    fill: "#1698B8"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5092 145.863H10.4967V148.453H41.5092V145.863Z",
    fill: "#1698B8"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4753 145.863H45.4627V148.453H76.4753V145.863Z",
    fill: "#1698B8"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M111.441 145.863H80.4283V148.453H111.441V145.863Z",
    fill: "#1698B8"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5092 151.18H10.4967V153.77H41.5092V151.18Z",
    fill: "#1698B8"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4753 151.18H45.4627V153.77H76.4753V151.18Z",
    fill: "#1698B8"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M111.441 151.18H80.4283V153.77H111.441V151.18Z",
    fill: "#1698B8"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4753 40.5566H45.4627V63.799H76.4753V40.5566Z",
    fill: "#1698B8"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4753 93.4482H45.4627V116.691H76.4753V93.4482Z",
    fill: "#1698B8"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3088 119.869L87.1895 118.134L66.7993 60.7855L61.9186 62.5209L82.3088 119.869Z",
    fill: "#00496F"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3109 43.5559C29.3089 60.5276 47.9846 69.3883 64.9563 63.3221C81.928 57.3241 90.7887 38.6484 84.7225 21.6767C78.7245 4.70505 60.0488 -4.15567 43.0771 1.91052C26.1054 7.9767 17.2447 26.5842 23.3109 43.5559ZM26.0373 42.6017C20.5845 27.1977 28.6273 10.226 44.0313 4.70506C59.4354 -0.747694 76.4071 7.29511 81.928 22.6991C87.4489 38.1032 79.3379 55.0749 63.9339 60.5958C48.5299 66.0485 31.5582 58.0057 26.0373 42.6017Z",
    fill: "#00496F"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M35.0343 9.81738C28.9681 17.5194 26.8551 28.1523 30.3994 38.1035C35.9203 53.5076 52.8239 61.6185 68.2961 56.0976C71.704 54.8707 74.703 53.1668 77.2931 50.9857C73.9533 55.2797 69.3866 58.6195 63.9338 60.5961C48.5298 66.0489 31.5581 58.0061 26.0372 42.6021C21.8113 30.5378 25.7646 17.5194 35.0343 9.81738Z",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M30.4675 38.1029C26.9232 28.1516 29.0361 17.5869 35.1023 9.81677C37.6924 7.63567 40.7595 5.93168 44.0994 4.70482C59.5034 -0.747937 76.4751 7.29487 81.996 22.6989C85.5403 32.6502 83.4273 43.2149 77.3611 50.985C74.7711 53.1661 71.7039 54.8701 68.3641 56.097C52.8919 61.5498 35.9202 53.5069 30.4675 38.1029Z",
    fill: "white"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M146.999 195.317C147.068 195.249 147.136 195.181 147.204 195.112C147.613 194.499 147.408 193.613 146.795 193.204L138.343 187.888C137.73 187.479 136.844 187.683 136.435 188.297C136.026 188.91 136.23 189.796 136.844 190.205L145.295 195.521C145.841 195.93 146.522 195.794 146.999 195.317Z",
    fill: "white"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M146.863 192.795C146.863 192.795 149.998 194.635 149.521 195.316C148.976 195.998 140.66 205.2 140.251 204.791C138.684 203.632 144.409 195.044 145.227 194.499C145.977 194.021 146.386 192.522 146.863 192.795Z",
    fill: "#055C7F"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9548 87.5561C74.9548 87.5561 68.8205 83.8755 67.1165 84.4889C65.4125 85.1023 70.8653 89.26 75.2275 89.26L74.9548 87.5561Z",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8408 86.6701C75.1592 87.6243 74.4776 88.5104 73.7961 89.3965C87.905 100.438 98.6061 101.393 113.397 91.8502C115.646 90.4188 115.441 89.4646 114.01 87.6925C114.146 87.2835 114.215 87.3517 114.01 87.6925C112.647 85.9203 111.897 85.9203 109.648 87.4198C94.6529 97.0985 91.4493 95.1218 75.8408 86.6701Z",
    fill: "#055C7F"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M105.899 208.949C105.967 208.949 106.103 208.949 106.172 208.949C106.921 208.812 107.399 208.062 107.262 207.313L105.286 197.566C105.149 196.816 104.399 196.339 103.65 196.475C102.9 196.612 102.423 197.361 102.559 198.111L104.536 207.858C104.672 208.54 105.286 208.949 105.899 208.949Z",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M102.832 203.291C104.331 203.223 105.763 203.086 107.262 202.882C102.832 179.367 99.5601 147.809 111.284 125.862C107.739 124.09 104.127 122.386 100.514 120.682C91.9944 139.834 99.2875 183.047 102.832 203.291Z",
    fill: "#00365D"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M141.001 194.499C142.023 193.34 143.046 192.182 144 190.955C117.827 171.052 110.193 155.307 114.555 122.046C110.534 121.432 106.58 120.819 102.559 120.273C102.968 157.08 113.805 171.87 141.001 194.499Z",
    fill: "#00496F"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M107.671 207.108C107.671 207.108 108.557 210.652 107.671 210.789C106.785 210.857 94.4482 211.266 94.38 210.721C94.1074 208.744 104.263 206.972 105.217 207.176C106.172 207.381 107.535 206.631 107.671 207.108Z",
    fill: "#055C7F"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M114.964 128.179C113.056 127.43 110.261 126.68 105.49 126.475C102.219 126.339 99.6284 126.475 97.6518 126.748C106.104 108.618 107.535 99.6207 106.785 94.5087C106.376 91.9868 107.399 89.3968 109.443 87.8973L110.261 87.2838C113.942 84.4211 119.327 86.4659 120.213 91.0326C120.485 92.5321 120.758 94.3043 120.826 96.2809C121.235 105.619 120.008 115.774 114.964 128.179Z",
    fill: "#39AECB"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M116.532 79.4457C114.965 83.3308 110.943 85.3756 108.558 84.4214C106.172 83.4671 106.308 79.8547 107.876 75.9696C109.444 72.0845 112.17 70.8576 114.556 71.88C116.941 72.9024 118.1 75.5606 116.532 79.4457Z",
    fill: "white"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M117.759 81.49C117.418 82.376 116.055 83.194 115.373 82.9213C114.692 82.6487 114.828 81.8308 115.237 80.9447C115.578 80.0586 116.464 79.377 117.146 79.6497C117.759 79.9223 118.1 80.6039 117.759 81.49Z",
    fill: "white"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M118.099 77.1963C118.099 77.1963 118.304 74.4017 116.736 72.6977C115.169 70.9938 111.352 69.6306 109.102 72.7659C109.102 72.7659 107.739 75.1515 110.738 76.5147C113.737 77.946 113.737 76.1057 114.691 78.1505C115.714 80.1953 117.486 79.5137 117.622 79.9226L118.099 77.1963Z",
    fill: "#333436"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M115.85 79.5818L111.488 79.1729C111.42 79.7863 110.943 85.5117 111.216 87.6246C111.352 88.3062 112.442 88.5788 113.669 88.3062C114.76 88.0336 115.51 87.4201 115.51 86.8067C115.373 85.5117 115.646 81.6948 115.85 79.5818Z",
    fill: "white"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M114.624 81.0129C113.874 80.4676 113.397 81.1492 112.034 82.3079C110.67 83.4667 107.876 83.7393 106.99 80.195C106.445 77.9457 105.831 81.899 105.831 81.899C105.899 83.8075 106.649 84.8299 108.08 85.4433C110.057 86.2612 112.783 85.5114 114.896 83.603C115.169 82.7169 115.169 81.4219 114.624 81.0129Z",
    fill: "#333436"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M106.853 80.127C106.853 80.127 106.922 80.127 106.99 80.1951C107.808 80.4678 111.625 81.6946 112.238 83.0578C112.92 84.5573 110.261 82.7852 109.443 81.8991C108.625 81.013 107.808 81.2857 106.99 81.2175C106.24 81.1493 105.763 80.3314 106.853 80.127Z",
    fill: "#333436"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3884 121.831L89.159 119.068L74.363 77.4539L66.5924 80.2168L81.3884 121.831Z",
    fill: "#8A0A3C"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M93.7668 114.002C93.2215 115.297 92.7444 116.524 92.131 117.751C115.578 119.387 121.576 114.547 120.008 92.8727C119.735 89.5329 119.054 89.192 116.191 89.9418C114.078 90.4871 114.146 91.714 114.351 94.6448C116.123 114.002 115.101 112.843 93.7668 114.002Z",
    fill: "#055C7F"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7209 114.684C94.7209 114.684 88.1094 111.14 86.3373 111.821C84.5651 112.571 90.495 116.661 95.0617 116.456L94.7209 114.684Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoNames);
export default __webpack_public_path__ + "static/media/no-names.74b84bbadfc3cd114b2dd4efbcadbda2.svg";
export { ForwardRef as ReactComponent };